import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// ===== GOOGLE AUTH START =====
import { GoogleOAuthProvider } from '@react-oauth/google';
// const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
const GOOGLE_CLIENT_ID = "185945132384-hrp020ibd2d9o1pkg7o4jndfs86apnnf.apps.googleusercontent.com";
const gCloud = import.meta.env.VITE_GOOGLE_CLIENT_ID
console.log("this is the google client id", gCloud)
// ===== GOOGLE AUTH END =====

// Unregister any previously installed service workers and clear their caches
// so existing users stop being served stale assets from the SW cache.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });

  if (typeof caches !== 'undefined') {
    caches.keys().then((keys) => {
      keys.forEach((key) => caches.delete(key));
    });
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* ===== GOOGLE AUTH START ===== */}
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
    {/* ===== GOOGLE AUTH END ===== */}
  </React.StrictMode>
);